var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2),_c('div',{staticClass:"triangle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }